'use strict';

import React, { useCallback, useEffect, useRef, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import { IoCheckmarkDoneOutline } from 'react-icons/io5'
import { RxReset } from 'react-icons/rx'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import ECUsersAbondementsHeader from '@/Abondement/ECUsersAbondements/Header'
import ECUserAbondementRow      from '@/Abondement/ECUsersAbondements/Row'
import Filters                  from '@/Abondement/ECUsersAbondements/Filters'

import Fetcher from '@fetcher/Fetcher'

import Message from '@Pure/Message'
import Loader  from '@Pure/Loader'

import bemit from '@function/bemit'

const { app } = window;

export default PageWrapper(function ECUsersAbondementsPage (props)
{
	const [selected, setSelected] = useState([]);
	const [members, setMembers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [searching, setSearching] = useState(false);
	const [fetch_id, setFetchId] = useState();
	const [abondements, setAbondements] = useState({ });

	const _fetch_data = useRef();

	const handleSearch = useCallback(function (value)
	{
		_fetch_data.current = { searched: value };

		setSearching(true);
		setSelected([]);
		setFetchId(uniqid());
	},
	[]);

	const handleFetch = useCallback(function (response)
	{
		setSelected([]);

		setAbondements((response.members || []).reduce(function (config, member)
		{
			const abondement = (response.abondements || [])
			.find(doc => doc.user === member.id);

			config[member.id] = abondement || { value: 0, user: member.id };

			return config;
		},
		{ }))

		setMembers(response.members || []);
		setLoading(false);
		setSearching(false);
	},
	[]);

	const handleFetchError = useCallback(function (data)
	{
		setSelected([]);
		setMembers([]);
		setLoading(false);
		setSearching(false);
	},
	[]);

	const toggleAll = useCallback(function (e)
	{
		setSelected(function (selected)
		{
			if (selected?.length) return [];

			return members
			.filter(user => user.validation_status === 'validated')
			.map(user => user.id);
		});
	},
	[members]);

	const handleMemberSelection = useCallback(function (e)
	{
		if (!e.target.name) return; // user id

		setSelected(function (selected)
		{
			if (e.target.checked)
			{
				return selected.concat([e.target.name]);
			}
			else
			{
				return selected.filter(item => item !== e.target.name);
			}
		});
	},
	[]);

	const handleUpdate = useCallback(function (e)
	{
		setLoading(true);

		setFetchId(uniqid());
	},
	[]);

	const rows = (members || []).map(function (member)
	{
		return (
			<ECUserAbondementRow key={ member.id }
				member={ member }
				abondement={ abondements[member.id] }
				onMemberSelection={ handleMemberSelection }
				selected={ selected.includes(member.id) }
			/>
		);
	});

	const ToggleAllIcon = selected?.length ? RxReset : IoCheckmarkDoneOutline;

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
	)
	: undefined;

	const search_loader = searching === true ?
	(
		<div className="u-full-width u-positioned" style={ { height: 150 } }>
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		</div>
	)
	: undefined;

	return (
		<Layout page_title="Abondement utilisateur" { ...props }>

			<div className="page-content abondement-admin-table">

				<HolidaysMessage />

				<div className="o-container">

					<Filters onUpdate={ handleUpdate }
						onSearch={ handleSearch }
						selected={ selected }
					/>

					<div className="u-full-width u-margin-top-30">
						<button type="button" onClick={ toggleAll }
							className={ bemit('c-btn', ['icon', 'users-abondements']) }>
							<ToggleAllIcon
								className="c-btn__icon u-margin-right-10"
							/>
							{
								selected?.length > 0
								? 'Tout déselectionner'
								: 'Sélectionner tous les utilisateurs actifs'
							}
						</button>
					</div>

					<div className="c-title u-margin-top-0">
						<h2 className="c-title__txt">Abondement</h2>
					</div>

					<ECUsersAbondementsHeader />

					{ search_loader || rows }

					{
						_fetch_data.current?.searched && rows.length === 0 ?
						(
							<Message color="blue" className="u-margin-top-0">
								Aucun résultat pour cette recherche.
							</Message>
						)
						: undefined
					}

				</div>

				{ loader }

			</div>

			<Fetcher url="/my-EC/my-users" onSuccess={ handleFetch }
				onError={ handleFetchError }
				key={ fetch_id }
				data={ _fetch_data?.current }
			/>

		</Layout>
	);
});